export default "__VITE_ASSET__BgkNj7gS__"